import { useEffect } from "react";

import { useNavigate } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { useAuth } from "@/components/lib/auth";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { SITE_NAME } from "@/css/constants";

import { HomeDashboard } from "./HomeDashboard";
import { HomeHeader } from "./HomeHeader";

function Home() {
  const { currentWorkspace, currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentWorkspace.isPersonal) {
      navigate("/coaching", { replace: true });
      return;
    }

    if (!currentUser.name) {
      navigate("/onboard", { replace: true });
      return;
    }
  }, [currentWorkspace, currentUser, navigate]);

  if (currentWorkspace.isPersonal || !currentUser.name) {
    return null;
  }

  return (
    <>
      <SEOHead
        title={`Home - ${SITE_NAME}`}
        description="View your upcoming and previous coaching sessions"
        canonicalPath="/home"
      />
      <Nav />
      <div className="md:ml-sidebar sm:ml-0">
        <HomeHeader />
        <div className="bg-lightest pb-1.5">
          <div className="max-w-content container">
            <div className="relative -top-13">
              <HomeDashboard />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function HomePage() {
  return (
    <Authenticate maxWidth="100%" layout="dashboard">
      <Home />
    </Authenticate>
  );
}
